import AvellaLanding from './AvellaModule';

export default AvellaLanding;
